<div class="card">
  <div class="card-header">Listado de {{ entity | uppercase }}</div>
  <div class="card-body">
    <app-fil-mercaderia (filter)="doFound($event)"> </app-fil-mercaderia>

    <div class="row table-responsive">
      <table class="table table-striped table-inverse">
        <thead class="thead-inverse">
          <tr>
            <!-- <th>id</th> -->
            <th>Grupo</th>
            <th>Nombre</th>
            <th>Código</th>
            <th>Contado</th>
            <th>Lista</th>
            <th>Mayorista</th>
            <th>Compras</th>
            <th>Vendidas</th>
            <th>Stock</th>
            <th>img</th>
            <th>acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <!-- <td scope="row">{{item.id}} </td> -->
            <td>{{ item.grupo.nombre }}</td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.serie }}</td>
            <td>{{ item.precioCon | currency }}</td>
            <td>{{ item.precioLis | currency }}</td>
            <td>{{ item.precioMay | currency }}</td>
            <td>{{ item.ing_stock }}</td>
            <td>{{ item.egr_stock }}</td>
            <td>{{ item.stock }}</td>
            <td>
              <app-image-preview [imgsrc]="item.photo"></app-image-preview>
            </td>
            <td>
              <button type="button" (click)="linkear(item.id)" class="btn btn-info btn-sm">
                <i class="fas fa-edit"></i>
              </button>
              &nbsp;
              <button type="button" (click)="preDelete(item)" class="btn btn-danger btn-sm">
                <i class="fas fa-trash"></i>
              </button>
              &nbsp;
              <app-imp-code-bar [grande]="false" [producto]="item" [conf]="conf"></app-imp-code-bar>
              &nbsp;
              <app-imp-code-bar [grande]="true" [producto]="item" [conf]="conf"></app-imp-code-bar>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-footer text-muted">
    <div class="btn-group" role="group" aria-label="">
      <a (click)="linkear(0)" class="btn btn-dark">Agregar</a>
    </div>
  </div>
</div>